<template>
	<div class="CroppableImage">
		<div v-if="loading" class="CroppableImage__loading" :style="'width:'+ showWidth + 'px; height:' + showHeight + 'px;'">
			<div class="spinner"></div>
		</div>
		<div v-else-if="showStaticPreview && !isPreviewActive">
			<img @click="isPreviewActive = !isPreviewActive" :src="(asset ? (asset.original ? asset.original.url : asset.url) : '')" alt=" ">
		</div>
		<div v-else-if="showWidth > 0 && showHeight > 0" class="row">
			<div class="col-xs-12">
				<div class="CroppableImage__wrapper">
					<croppa
					ref="image"

					:class="{ 'CroppableImage__img': true, 'CroppableImage__img--round': type == 'users' }"

					@init="croppaOnInit"
					@file-choose="croppaOnFileChoose"

					:placeholder="$t('Choose an image')"
        			:disable-drag-and-drop="false"
					:initial-image="(asset ? (asset.original ? asset.original.url : asset.url) : false)"
					@initial-image-loaded="applyMeta"

					:initial-size="'contain'"
					:replace-drop="true"
					:quality="width / showWidth"
					:width="showWidth"
					:height="showHeight"
					:disable-rotation="true"
					:remove-button-size="32"
					:remove-button-color="'#a3248f'"
					></croppa>
				</div>
				<div>
					<button type="button" @click="save" class="st-btn st-btn--primary st-btn--small">Save Image</button>
					<button v-if="showStaticPreview" @click="isPreviewActive = !isPreviewActive" type="button" class="st-btn st-btn--error st-btn--small">Cancel</button>
				</div>
				<div class="margin-top-medium margin-bottom-medium">
					{{ $t('Hold left mouse button to move picture. Use Mousewheel to zoom in & out.')}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import help_rest from '@/helpers/rest';
import forEach from 'lodash/forEach';
// getMetadata
// applyMetadata

export default {
	name: 'CroppableImage',
	props: {
		fieldname: {
			type: String,
			default: 'image',
		},
		id: {
			type: Number,
			default: 0,
		},
		pid: {
			type: Number,
			default: 0,
		},
		cid: {
			type: Number,
			default: 0,
		},
		type: {
			type: String,
			default: 'assets',
		},
		quality: {
			type: Number,
			default: 1,
		},

		height: {
			type: Number,
			default: 320,
		},
		width: {
			type: Number,
			default: 640,
		},
		showStaticPreview: {
			type: Boolean,
			default: false,
		}
	},
	data(){
		return {
			isPreviewActive: false,
			showWidth: 	0,
			showHeight: 0,
			original: 	false,
			asset: 		{},
			loading: 	false,
		};
	},
	watch: {
		'fieldname': function () { this.init(); },
		'id': function () { this.init(); },
		'type': function () { this.init(); },
		'width': function () { this.init(); },
      	'height': function () { this.init(); },
      	'quality': function () {
        	this.$refs.image.refresh();
      	}
    },
	mounted(){
		this.init();
	},
	methods: {
		...help_rest,
		croppaOnFileChoose(file){
			this.original = file;
		},
		croppaOnInit(croppa){},
		save(){
			const channel 	= this.$store.getters.channel,
				  self 		= this;

			var image 			= this.$refs.image,
				imageID 		= self.id,
				imageName 		= '';



			image.promisedBlob('image/png', this.quality)
			.then(blob => {
				// '/assets/{aid}/{format}'
				var newImage = self.original;
				if(newImage){
					var org_image_url 	= channel.urls.base + self.type + '/' + imageID;
					imageName 			= newImage.name;

					if(imageID <= 0){
						org_image_url 	= channel.urls.postAsset.replace(':aid:', imageName);
					}
					if(self.pid > 0 && self.cid > 0){
						org_image_url 	= channel.urls.base + 'presentations/' + self.pid + '/' + self.cid;
					}


					var formData = new FormData();
					formData.append(this.fieldname, newImage, imageName);
					return self.restpost(org_image_url, formData, 'async')
						.then(message => {
							var asset = asset = typeof message[self.fieldname] === 'undefined' ? message : message[self.fieldname];
							if(asset){
								imageID = asset.id;
								self.original = false;
								self.$emit('input', imageID)
							}

							return blob;
						}).catch(err => {
							console.error(err);
						});
				} else {
					imageName = self.asset.basename;
					return blob;
				}
			})
			.then(blob => {
				if(imageID && self.width && self.height){
					// '/assets/{aid}/{format}'
					var formData = new FormData();
					formData.append('metadata', 			JSON.stringify(self.$refs.image.getMetadata()));
					formData.append(this.fieldname, 		blob, imageName);

					return self.restpost(channel.urls.base + self.type + '/' + imageID + '/' + self.width + 'x' + self.height, formData, 'async')
					.then(resp => {
						return resp;
					}).catch(err => {
						console.error(err);
					});
				}
			})
			.then(response => {
				self.$emit('saved', response);
			});
		},
		applyMeta(){
			const self = this;
			if(this.asset.metadata){
				self.$refs.image.applyMetadata(self.asset.metadata);
			} else if(self.asset.variations){
				forEach(self.asset.variations, variation => {
					if(variation.width == this.width && variation.height == this.height){
						self.$refs.image.applyMetadata(variation.metadata);
					}
				})
			}
		},
		init(){
			const channel = this.$store.getters.channel;
			var self = this,
				reacts = this.$el.getBoundingClientRect();

			const scale = Math.min( reacts.width / (this.width), (reacts.height > 150 ?  reacts.height : window.innerHeight/2) / (this.height) );

			this.showWidth = this.width * (scale <= 1 ? scale : 1);
			this.showHeight = this.height * (scale <= 1 ? scale : 1);

			if(self.id > 0){
				self.loading = true;
				self.restget(channel.urls.base + self.type + '/' + self.id, 'async')
				.then(message => {
					if(!message) return;
					var asset = false;
					if(asset = typeof message[self.fieldname] === 'undefined' ? message : message[self.fieldname]){
						self.asset = asset;
						self.$emit('input', self.asset)
					}

					self.loading = false;
				});
			}
		}
	}
}
</script>


<style>
.CroppableImage {
	line-height: 1;
}
.CroppableImage__wrapper {
    /*display: flex;
    justify-content: center;
    align-items: center;*/
}
.CroppableImage__loading {
	display: flex;
	justify-content: center;
	align-items: center;
	background: #d9d9d9;
}
.CroppableImage__img--round {
	border-radius: 50%;
}
.CroppableImage__img--round canvas {
	border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/CroppableImage.vue